import styled from '@emotion/styled';
import { IGenericCssObject } from './StoryBlockerV3.interface';



export const StoryBlockerStyle = {
  storyBlocker: {
    border: '1px solid #F6F6F6',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.04)',
    borderRadius: '12px',
    padding: '40px',
    paddingMobile: '16px',
    marginMobile: '16px',
  }
}
export const StoryBlockerInnerStyle = {
  storyBlockerInner: {
    display: 'flex',
    alignItems: 'center',
  }
}

export const HeadingStyle = {
  heading: {
    fontSize: '32px',
    lineHeight: '36px',
    color: '#1a1a1a',
    marginBottom: '24px',
    fontSizeMobile: '16px',
    lineHeightMobile: '24px',
    marginBottomMobile: '16px',
  }
}

export const HeadingWrapperStyle = {
  headingWrapper: {
    display: 'flex',
  }
}

export const SubHeadingStyle = {
  subHeading: {
    fontSize: '20px',
    lineHeight: '24px',
    color: '#1a1a1a',
    fontWeight: '600',
    marginBottom: '20px',
    fontSizeMobile: '12px',
    lineHeightMobile: '16px',
    marginBottomMobile: '16px',
  }
}

export const ListWrapperStyle = {
  listWrapper: {
    marginBottom: '32px',
    marginBottomMobile: '20px',
  }
}

export const ListItemStyle = {
  listItem: {
    fontSize: '20px',
    lineHeight: '24px',
    color: '#595959',
    marginBottom: '16px',
    paddingLeft: '24px',
    position: 'relative',
    fontSizeMobile: '12px',
    lineHeightMobile: '16px',
  },
  listItemIcon: {
    position: 'absolute',
    height: '2px',
    background: '#1a1a1a',
    borderRadius: '1000px',
  },
  listItemIconBefore: {
    width: '7px',
    left: '0',
    top: '13px',
    topMobile: '9px',
    transform: 'rotate(55deg)',
  },
  listItemIconAfter: {
    width: '12px',
    left: '2px',
    top: '11px',
    topMobile: '7px',
    transform: 'rotate(-55deg)',
  }
}

export const InfoWrapperStyle = {
  infoWrapper: {
    position: 'relative',
    width: '50px',
  },
}

export const InfoStyle = {
  info: {
    position: 'absolute',
    top: '0',
    desktopTop: '4px',
    right: '0',
    desktopRight: '10px',
  }
}

export const InfoIconStyle = {
  infoIcon: {
    border: '2px solid #E21B22',
    display: 'block',
    width: '16px',
    height: '16px',
    textAlign: 'center',
    cursor: 'pointer',
    borderRadius: '50%',
    color: '#E21B22',
    fontSize: '11px',
    lineHeight: '13px',
    fontWeight: '600',
    desktopFontSize: '12px',
    desktopLineHeight: '16px',
    desktopWidth: '20px',
    desktopHeight: '20px',
  }
}

export const PopupStyle = {
  popup: {
    display: 'none',
    position: 'absolute',
    bottom: '32px',
    right: '-20px',
    background: '#1a1a1a',
    width: '417px',
    boxShadow: '0px 8px 25px rgba(0, 0, 0, 0.08)',
    borderRadius: '8px',
    zIndex: '1',
    widthMobile: '208px',
  },
}

export const ShowPopupStyle = {
  ...PopupStyle,
  popup: {
    ...PopupStyle.popup,
    display: 'flex'
  }
}

export const CloseBtnStyle = {
  closeBtn: {
    position: 'absolute',
    width: '20px',
    height: '20px',
    right: '12px',
    top: '8px',
    cursor: 'pointer',
    mobileRight: '8px',
  },
  clsBtnArrow: {
    position: 'absolute',
    content: '""',
    width: '16px',
    height: '2px',
    top: '10px',
    left: '0',
    background: '#ccc',
  },
  clsBtnPrevArrow: {
    transform: 'rotate(45deg)',
  },
  clsBtnNextArrow: {
    transform: 'rotate(-45deg)',
  },
}

export const CloseBtn = styled.span`
  position: ${(props: IGenericCssObject) => props.styles.closeBtn?.position};
  width: ${(props: IGenericCssObject) => props.styles.closeBtn?.width};
  height: ${(props: IGenericCssObject) => props.styles.closeBtn?.height};
  right: ${(props: IGenericCssObject) => props.styles.closeBtn?.right};
  top: ${(props: IGenericCssObject) => props.styles.closeBtn?.top};
  cursor: ${(props: IGenericCssObject) => props.styles.closeBtn?.cursor};
  &:before,
    &:after {
      position: ${(props: IGenericCssObject) =>
    props.styles?.clsBtnArrow?.position};
      content: ${(props: IGenericCssObject) =>
    props.styles?.clsBtnArrow?.content};
      width: ${(props: IGenericCssObject) => props.styles?.clsBtnArrow?.width};
      height: ${(props: IGenericCssObject) =>
    props.styles?.clsBtnArrow?.height};
      left: ${(props: IGenericCssObject) => props.styles?.clsBtnArrow?.left};
      top: ${(props: IGenericCssObject) => props.styles?.clsBtnArrow?.top};
      background: ${(props: IGenericCssObject) => props.styles?.clsBtnArrow?.background};
      transform: ${(props: IGenericCssObject) => props.styles?.clsBtnArrow?.transform};
    }
    &:before {
      transform: ${(props: IGenericCssObject) => props.styles?.clsBtnPrevArrow?.transform};
    }
    &:after {
      transform: ${(props: IGenericCssObject) => props.styles?.clsBtnNextArrow?.transform};
    }
  @media screen and (max-width:767px) {
    right: ${(props: IGenericCssObject) => props.styles.closeBtn?.mobileRight};
  }
`;

export const StoryBlockerContainer = styled.div`
  // background: url(https://static.toiimg.com/photo/99553042.cms) no-repeat;
  // backgroundsize: contain;
  border: ${(props: IGenericCssObject) => props.styles.storyBlocker?.border};
  box-shadow: ${(props: IGenericCssObject) => props.styles.storyBlocker?.boxShadow};
  border-radius: ${(props: IGenericCssObject) => props.styles.storyBlocker?.borderRadius};
  padding: ${(props: IGenericCssObject) => props.styles.storyBlocker?.padding};
  @media screen and (max-width:767px) {
    padding: ${(props: IGenericCssObject) => props.styles.storyBlocker?.paddingMobile};
    margin: ${(props: IGenericCssObject) => props.styles.storyBlocker?.marginMobile};
  }
  .gdprBlocker{
    display: flex;
    align-items: center;
    flex-flow: column;
  }
`;

export const StoryBlockerInner = styled.div`
// background: #fff;

  @media screen and (min-width:768px) {
    display: ${(props: IGenericCssObject) => props.styles.storyBlockerInner?.display};
    align-items: ${(props: IGenericCssObject) => props.styles.storyBlockerInner?.alignItems};
  }

  .gdprHeading{
    text-align: center;
  }

  .btnGrp {
    margin-bottom:20px;
    @media screen and (min-width:768px) {
      display: flex;
    }

    a {
      font-size: 24px;
      line-height: 30px;
      font-weight: 700;
      padding: 24px 16px;
      border-radius: 12px;
      @media screen and (min-width:1000px) and (max-width:1420px) {
        font-size: 22px;
      }
      @media screen and (min-width:768px) and (max-width:999px) {
        font-size: 16px;
      }
      @media screen and (min-width:768px) {
        cursor: pointer;
        +a {
          margin-left: 12px;
        }
      }
      @media screen and (max-width:767px) {
        font-size: 12px;
        line-height: 16px;
        padding: 8px 16px;
        border-radius: 8px;
        display: block;
      }

      &.viewplan {
        color: #E21B22;
        font-weight: 600;
        text-align: center;
        font-size: 24px;
        line-height: 32px;
        margin-top: 20px;
        border: 1px solid #E21B22;
        @media screen and (max-width:767px) {
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
        }
      }

      &.buyplan {
        background: #E21B22;
        color: #fff;
        text-align:center;
        flex:1;
        position: relative;
        z-index: 1;

        &:before, &:after {
          content: '';
          position: absolute;
          left:0;
          height: 100%;
          border-radius:inherit;
        }

        &:before {
          bottom: 0;
          width: 0%;
          background-color: rgba(26, 26, 26, 0.2);
          transition: all 0.5s;
          z-index: -1;
        }

        &:hover {
          &:before {
            width: 100%;
          }
        }

        &:after {
          width: 100%;
          background-color: #e21b22;
          top: 0;
          z-index: -2;
        }
        &:hover {
          background: #fff;
        }
      }
    }
  }
  .offer {
    display: flex;
    flex-flow: column;
    align-items: center;
    @media screen and (min-width:767px) {
      padding-top: 24px;
    }
    > p {
      font-size: 24px;
      font-weight: 700;
      line-height: 24px;
      color: #1A1A1A;
      text-align:center;
      strong {
        font-weight:600;
      }
      @media screen and (max-width:767px) {
        font-size: 12px;
        line-height: 14px;
      }
    }
  }
  @media screen and (min-width:768px) {
    .storyblockercontent {
      margin-left: 40px;
    }
  }
`;

export const HeadingWrapper = styled.div`
  @media screen and (max-width:767px) {
    display: ${(props: IGenericCssObject) => props.styles.headingWrapper?.display};
  }
`;

export const Heading = styled.h2`
  font-size: ${(props: IGenericCssObject) => props.styles.heading?.fontSize};
  line-height: ${(props: IGenericCssObject) => props.styles.heading?.lineHeight};
  color: ${(props: IGenericCssObject) => props.styles.heading?.color};
  margin-bottom: ${(props: IGenericCssObject) => props.styles.heading?.marginBottom};
  @media screen and (max-width:767px) {
    font-size: ${(props: IGenericCssObject) => props.styles.heading?.fontSizeMobile};
    line-height: ${(props: IGenericCssObject) => props.styles.heading?.lineHeightMobile};
    margin-bottom: ${(props: IGenericCssObject) => props.styles.heading?.marginBottomMobile};
  }
  img {
    vertical-align: top;
  }
`;

export const SubHeading = styled.h6`
  font-size: ${(props: IGenericCssObject) => props.styles.subHeading?.fontSize};
  line-height: ${(props: IGenericCssObject) => props.styles.subHeading?.lineHeight};
  color: ${(props: IGenericCssObject) => props.styles.subHeading?.color};
  font-weight: ${(props: IGenericCssObject) => props.styles.subHeading?.fontWeight};
  margin-bottom: ${(props: IGenericCssObject) => props.styles.subHeading?.marginBottom};
  @media screen and (max-width:767px) {
    font-size: ${(props: IGenericCssObject) => props.styles.subHeading?.fontSizeMobile};
    line-height: ${(props: IGenericCssObject) => props.styles.subHeading?.lineHeightMobile};
    margin-bottom: ${(props: IGenericCssObject) => props.styles.subHeading?.marginBottomMobile};
  }
`;

export const ListWrapper = styled.ul`
  margin-bottom: ${(props: IGenericCssObject) => props.styles.listWrapper?.marginBottom};
  @media screen and (max-width:767px) {
    margin-bottom: ${(props: IGenericCssObject) => props.styles.listWrapper?.marginBottomMobile};
  }
`;

export const ListItem = styled.li`
  font-size: ${(props: IGenericCssObject) => props.styles.listItem?.fontSize};
  line-height: ${(props: IGenericCssObject) => props.styles.listItem?.lineHeight};
  color: ${(props: IGenericCssObject) => props.styles.listItem?.color};
  padding-left: ${(props: IGenericCssObject) => props.styles.listItem?.paddingLeft};
  position: ${(props: IGenericCssObject) => props.styles.listItem?.position};
  &:not(:last-child) {
    margin-bottom: ${(props: IGenericCssObject) => props.styles.listItem?.marginBottom};
  }
  @media screen and (max-width:767px) {
    font-size: ${(props: IGenericCssObject) => props.styles.listItem?.fontSizeMobile};
    line-height: ${(props: IGenericCssObject) => props.styles.listItem?.lineHeightMobile};
  }
  &:before, &:after {
  position: ${(props: IGenericCssObject) => props.styles.listItemIcon?.position};
  content: '';
  height: ${(props: IGenericCssObject) => props.styles.listItemIcon?.height};
  background: ${(props: IGenericCssObject) => props.styles.listItemIcon?.background};
  border-radius: ${(props: IGenericCssObject) => props.styles.listItemIcon?.borderRadius};
  }
  &:before {
    width: ${(props: IGenericCssObject) => props.styles.listItemIconBefore?.width};
    left: ${(props: IGenericCssObject) => props.styles.listItemIconBefore?.left};
    top: ${(props: IGenericCssObject) => props.styles.listItemIconBefore?.top};
    transform: ${(props: IGenericCssObject) => props.styles.listItemIconBefore?.transform};
    @media screen and (max-width:767px) {
      top: ${(props: IGenericCssObject) => props.styles.listItemIconBefore?.topMobile};
    }
  }
  &:after {
    width: ${(props: IGenericCssObject) => props.styles.listItemIconAfter?.width};
    left: ${(props: IGenericCssObject) => props.styles.listItemIconAfter?.left};
    top: ${(props: IGenericCssObject) => props.styles.listItemIconAfter?.top};
    transform: ${(props: IGenericCssObject) => props.styles.listItemIconAfter?.transform};
    @media screen and (max-width:767px) {
      top: ${(props: IGenericCssObject) => props.styles.listItemIconAfter?.topMobile};
    }
  }
`;

export const InfoWrapper = styled.div`
  position: ${(props: IGenericCssObject) => props.styles.infoWrapper?.position};
  width: ${(props: IGenericCssObject) => props.styles.infoWrapper?.width};
`;

export const Popup = styled.div`
  display: ${(props: IGenericCssObject) => props.styles.popup?.display};
  position: ${(props: IGenericCssObject) => props.styles.popup?.position};
  bottom: ${(props: IGenericCssObject) => props.styles.popup?.bottom};
  right: ${(props: IGenericCssObject) => props.styles.popup?.right};
  background: ${(props: IGenericCssObject) => props.styles.popup?.background};
  width: ${(props: IGenericCssObject) => props.styles.popup?.width};
  box-shadow: ${(props: IGenericCssObject) => props.styles.popup?.boxShadow};
  z-index: ${(props: IGenericCssObject) => props.styles.popup?.zIndex};
  border-radius: ${(props: IGenericCssObject) => props.styles.popup?.borderRadius};
  @media screen and (max-width:767px) {
    width: ${(props: IGenericCssObject) => props.styles.popup?.widthMobile};
  }
  .closePopup {
    position: fixed;
    width:100%;
    height: 100%;
    left:0;
    top:0;
  }
`;


export const Info = styled.div`
  position: ${(props: IGenericCssObject) => props.styles.info?.position};
  right: ${(props: IGenericCssObject) => props.styles.info?.right};
  top: ${(props: IGenericCssObject) => props.styles.info?.top};
  @media screen and (min-width:768px) {
    right: ${(props: IGenericCssObject) => props.styles.info?.desktopRight};
    top: ${(props: IGenericCssObject) => props.styles.info?.desktopTop};
  }
`;

export const InfoIcon = styled.span`
  font-size: ${(props: IGenericCssObject) => props.styles.infoIcon?.fontSize};
  line-height: ${(props: IGenericCssObject) => props.styles.infoIcon?.lineHeight};
  color: ${(props: IGenericCssObject) => props.styles.infoIcon?.color};
  font-weight: ${(props: IGenericCssObject) => props.styles.infoIcon?.fontWeight};
  border: ${(props: IGenericCssObject) => props.styles.infoIcon?.border};
  display: ${(props: IGenericCssObject) => props.styles.infoIcon?.display};
  width: ${(props: IGenericCssObject) => props.styles.infoIcon?.width};
  height: ${(props: IGenericCssObject) => props.styles.infoIcon?.height};
  text-align: ${(props: IGenericCssObject) => props.styles.infoIcon?.textAlign};
  border-radius: ${(props: IGenericCssObject) => props.styles.infoIcon?.borderRadius};

  @media screen and (min-width:768px) {
    cursor: ${(props: IGenericCssObject) => props.styles.infoIcon?.cursor};
    font-size: ${(props: IGenericCssObject) => props.styles.infoIcon?.desktopFontSize};
    line-height: ${(props: IGenericCssObject) => props.styles.infoIcon?.desktopLineHeight};
    width: ${(props: IGenericCssObject) => props.styles.infoIcon?.desktopWidth};
    height: ${(props: IGenericCssObject) => props.styles.infoIcon?.desktopHeight};
  }
`;

export const Container = styled.div`
  margin: 16px;
  border-radius: 0;
  background: #FFE9E2;
  padding: 8px;
  border: 1px solid #F6F6F6;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.04);
`;

export const ContainerInner = styled.div`
  background: white;
  padding: 16px;
`;

export const Title = styled.h1`
  font-size: 16px;
  line-height: 24px;
  margin-top: 0px;
  margin-bottom: 16px;
  font-weight: 400;
  color: #1a1a1a;
`;

export const SubTitle = styled.h2`
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 16px;
  color: #1a1a1a;
  font-weight: 600;
`;

export const ParaTag = styled.p`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin-bottom: 12px;
  color: #1a1a1a;
`;

export const List = styled.ul`
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #E6E6E6;
`;

export const ListItems = styled.li`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  font-size: 15px;
  line-height: 24px;
  color: #595959;
  padding-left: 20px;
  position: relative;
  list-style: none;
  &::before {
    top: 8px;
    height: 7px;
    background: #ED193B;
    left: 2px;
    z-index: 10;
    transform: rotate(45deg);
  }
  &::after {
    display:none;
  }
  &::before, &::after {
    position: absolute;
    content: '';
    width: 7px !important;
  }
`;

export const Button = styled.div`
  margin-bottom: 12px;
  text-align: center;
  a {
    background: #E21B22;
    color: #fff;
    text-align: center;
    position: relative;
    z-index: 1;
    display: inline-block;
    margin: 0 auto;
    border-radius: 4px;
    font-size: 16px;
    line-height: 24px;
    padding: 6px 16px;
    width: 100%;
    font-weight: 700;
    &:before {
      bottom: 0;
      width: 0%;
      background-color: rgba(26, 26, 26, 0.2);
      transition: all 0.5s;
      z-index: -1;
    }
    &:after {
      width: 100%;
      background-color: #e21b22;
      top: 0;
      z-index: -2;
    }
    &:before, &:after{
      content: '';
      position: absolute;
      left: 0;
      height: 100%;
      border-radius: inherit;
    }
  }
`;

export const LinkButton = styled.div`
  text-align: center;

  a {
    font-size: 14px;
    color: #ED193B;
    text-decoration: underline;
    background-color: transparent;
  }
`;

export const SignInBtn = styled.div`
  text-align: center;

  div {
    background: transparent;
    color: #000000;
    font-size: 13px;
    padding: 0;

    a {
      font-size: 13px;
      text-decoration: underline;

      &:after {
        display: none;
      }
    }
  }
`;

export const FreeTrailText = styled.div`
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 18px;
    text-align: center;
    line-height: 24px;
    & span{
      color: #E21B22;
    }
`;